import { FastField, Field } from 'formik';
import styled, { css } from 'styled-components';
import media from '../../../constants/media';

export const inputStyles = css`
	display: block;
	width: 100%;
	height: 5rem;
	padding: 0 2.5rem;
	font-size: 2rem;
	color: ${({ theme }) => theme.colors.textDarker};
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	border-radius: 2px;
	transition: border-color 100ms;

	${media.tablet`
		font-size: 1.7rem;
	`};

	/* ::placeholder {
		color: ${({ theme }) => theme.colors.textDarker};
	} */

	&:hover {
		border-color: ${({ theme }) => theme.colors.borderDark};
	}

	&:focus {
		border-color: ${({ theme }) => theme.colors.primary};
		box-shadow: 0 2px 6px ${({ theme }) => theme.colors.primary}33; /* primary @ ~20% */
	}

	${({ disabled }) =>
		disabled &&
		css`
			opacity: 0.8;
			pointer-events: none;
			background: hsl(0, 0%, 95%);
		`};
`;

export const Input = styled.input`
	${inputStyles};
`;

export const StyledFormikField = styled(Field)`
	${inputStyles};
`;

export const StyledFormikFastField = styled(FastField)`
	${inputStyles};
`;

export const StyledFormikTextArea = styled(Field)`
	${inputStyles};
	min-height: 15rem;
	padding: 2rem;
	resize: none;
`;

export const StyledTextArea = styled(Field)`
	${inputStyles};
	height: 10rem;
	padding: 1.25rem 2.5rem 0rem 2.5rem;
`;
